var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row d-flex"},[_c('div',{staticClass:"col-lg-12"},[_c('card',{staticClass:"card-calendar"},[_c('calendar')],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }